import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 1, delay, ease: [0.76, 0, 0.24, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ number, label }) => (
  <div className="flex items-center gap-4 mb-12">
    <span className="font-label text-xs text-[#C4A27A] tracking-[0.3em]">{number}</span>
    <span className="w-12 h-px bg-[#C4A27A]/40" />
    <span className="font-label text-xs uppercase tracking-[0.3em] text-[#8A8A93]">{label}</span>
  </div>
);

export default Reveal;
